import { render } from "./ExperimentPage.vue?vue&type=template&id=598aa4f6&scoped=true"
import script from "./ExperimentPage.vue?vue&type=script&lang=js"
export * from "./ExperimentPage.vue?vue&type=script&lang=js"

import "./ExperimentPage.vue?vue&type=style&index=0&id=598aa4f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598aa4f6"]])

export default __exports__